export const MIN_FILTERABLE_ITEMS = 1;
export const USER_MENU_DROPDOWN_WIDTH = '424px';
export const LOGO_TOOLTIP_DELAY = 1000;
export const MIN_VIRTUALIZED_ITEMS_COUNT = 50;
export const TOOLTIP_MAX_WIDTH = 250;
export const TOOLTIP_OFFSET = -2;
export const BADGE_OFFSET_WITH_AMOUNT = 18;
export const BADGE_OFFSET_WITHOUT_AMOUNT = 16;
